import AbstractListView from '@UI/Store/AbstractListView';
import type AccountFacilityView from '@UI/Store/AccountFacilities/Views/AccountFacilityView';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class AccountFacilitiesListView extends AbstractListView<AccountFacilityView> {
	readonly accountId: number;
	/** True when the server list may be out of date and must be read again; the list stays displayed meanwhile. */
	readonly isRefreshRequested: boolean;

	constructor(list: readonly AccountFacilityView[], accountId: number, isRefreshRequested = false) {
		super(list, 'AccountFacilitiesListView');

		this.accountId = accountId;
		this.isRefreshRequested = isRefreshRequested;

		Object.freeze(this);
	}

	requestRefresh(): AccountFacilitiesListView {
		return new AccountFacilitiesListView(this.list, this.accountId, true);
	}

	clearRefreshRequest(): AccountFacilitiesListView {
		if (!this.isRefreshRequested) {
			return this;
		}

		return new AccountFacilitiesListView(this.list, this.accountId, false);
	}
}

export default AccountFacilitiesListView;
